import type { PluginManifest } from "@d12labs/plugins/types";

export const manifest: PluginManifest = {
	name: "notes",
	label: "Notes",
	description:
		"Personal notes — the canonical sample plugin demonstrating the chassis conventions.",
	version: "0.1.0",
	navItems: [{ label: "Notes", href: "/notes", icon: "StickyNote" }],
};
